<template>
    <div>

        <div class="col-md-10 col-sm-12 pl-0" >
            <h4 class="atlhr-dashboard-title mt-10">Leave &amp; Attendance Import<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave &amp; Attendance Management / Leave &amp; Attendance Import</span></h4>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>  
        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <div class="row clearfix mb-2"><div class="col-md-12">Click browse and upload file</div></div>
            <b-form-file id="datafile" name="datafile" @change="uploadLeaveFile"  accept=".xlsx,.xls"></b-form-file>
                
                <div v-if='errormsg'>
                    <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                    <ul class="list-group ">           
                        <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                    </ul>
                </div>
        </b-overlay>
  </div>
</template>
<script>



    export default{
        mounted() {            
            //alert(this.cu);
        },
        props: ['type'],
        data(){            
            return {
                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                showoverlay : false,
                upload_url : '',
                process_url : '',
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                uploaded_file_data : "",
                imptimeout: false,
            }
        },
        methods:{     

            


            uploadLeaveFile:function(event) 
            {
                if(!this.checkNet()) return false;
                this.uploaded_file_data = this.$api_url+"/leave-attendances";
                this.showoverlay = true;                
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.$api_url+'/employee/leave/import/import', data , config).
                    then(function (response)
                    {
                        this.$bvToast.toast('Successfully Imported', {
                                            title: `Success`,
                                            variant: 'info',
                                            solid: true
                                        });                        
                    
                        this.showoverlay = false; 

                        window.location.href = this.uploaded_file_data;
                        
                        
                        
                    }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                    this.showoverlay = false; 
            },
        },
        created: function(){
            //this.setUrls();
        },
        
        computed: 
        {
            
        }
    }
</script>
